import { lazy } from 'react'

import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'

export const GoalAssignmentRoutes = [
  {
    nameUrl: 'Asignacion-meta',
    path: urlRoutes.private.goalAssignment.url,
    element: lazy(() => import('presentation/pages/goalAssignment')),
    rols: ['*'],
  },
]
